import React from 'react'
import ContentfulJsonLdBlocks from 'src/components/shared/ContentfulJsonLdBlocks'
import Layout from 'src/components/layouts'
import FactsPage from 'src/components/pages/Facts'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'
import { getTrustMarkersCombinationById } from 'src/common/getTrustMarkersCombinationById'
import logger from 'src/common/logger'
import { getMegamenuData } from 'src/common/back/megamenu'

export async function getServerSideProps(context) {
  const jsonLdSchemas = await getContentfulJsonLd('facts/')
  let megamenuData = null
  let trustMarkersCombination = {}
  try {
    trustMarkersCombination =
      (await getTrustMarkersCombinationById('facts', context?.preview)) ?? {}
    megamenuData = await getMegamenuData(context)
  } catch (error) {
    logger.error('facts page: trust markers fetch failed', { error })
  }

  return {
    props: {
      trustMarkersCombination,
      megamenuData: megamenuData || null,
      jsonLdSchemas,
    },
  }
}

const Facts = ({ trustMarkersCombination, megamenuData, jsonLdSchemas }) => {
  return (
    <>
      <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
      <Layout isBrandPage={true} megamenuData={megamenuData}>
        <FactsPage trustMarkersCombination={trustMarkersCombination} />
      </Layout>
    </>
  )
}

export default Facts
